import CoursePlayerContainer from './CoursePlayerContainer';
export { default as SinglePlayerContainer } from './SinglePlayerContainer';

export default CoursePlayerContainer;
